import React from "react";
import Button from "components/CustomButton/CustomButton.jsx";
import ReactTable from 'react-table'
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { Link } from 'react-router-dom';
import { history } from 'helpers';
import ReactAJAXTable from "../../components/ReactAJAXTable/ReactAJAXTable";
import { userActions } from "../../actions";
import loopBackAPIAdapter from "../../components/ReactAJAXTable/adapters/loopBackAPIAdapter";
import Clearfix from "../../components/Custom/Clearfix";
import { withTranslation } from 'react-i18next';


class UsersTable extends React.Component {

    constructor(props) {
        super(props)
    }


    render() {

        const { t } = this.props;

        const filtersCustomizer = {
            isActive: function( value ){
                return (value=='true');
            }
        }
    
        return (
            <Card>
                <CardHeader>
                    <CardTitle>
                        {t("Elenco utenti")}
                        <span className="pull-right">
                            {this.props.additionalTopButtons}
                            {
                                !this.props.hideNewButton &&
                                <Link onClick={this.props.onClickNew ? this.props.onClickNew : () => { }} 
                                    to={"/users/edit/0"}
                                    className="custom-display-inline-block custom-v-align-top">
                                    <Button color="primary" round size="sm" className="custom-no-margin">{t("Nuovo")}</Button>
                                </Link>
                            }
                        </span>
                        <Clearfix />
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <ReactAJAXTable
                        rerenderKey={this.props.rerenderKey}
                        topComponent={this.props.topComponent}
                        {...this.props.users}
                        filtersCustomizer={ filtersCustomizer }
                        AJAXAdapter={loopBackAPIAdapter} // Adapter per filtri (vengono passati all'actionCreator `actionCreator.filterCount` e `actionCreator.filter`)
                        dispatch={this.props.dispatch} // Methodo `dispatch` di Redux
                        actionCreator={userActions} // Action creator (deve implementare il metodo `filterCount`)
                        noRecordText={this.props.noRecordText || "Nessun utente trovato"} // Testo in caso di nessun record
                        actionCreatorOverride={this.props.actionCreator}
                        onChangeSelectedItems={this.props.onChangeSelectedItems}
                        columns={this.props.columns} // Definizione delle colonne della tabella (secondo il componente `ReactTable`)
                        data={this.props.users.loading ? [] : this.props.data} // Record da visualizzare (secondo il componente `ReactTable`)
                        footerComponent={this.props.footerComponent}
                    />
                </CardBody>
            </Card>
        );
    }

}

export default UsersTable = withTranslation()(UsersTable);


// WEBPACK FOOTER //
// ./src/views/Users/UsersTable.jsx